import { render, staticRenderFns } from "./StoreWithdrawalsView.vue?vue&type=template&id=45827901&lang=pug"
import script from "./StoreWithdrawalsView.vue?vue&type=script&lang=js"
export * from "./StoreWithdrawalsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports